import React, { useEffect } from "react"
import { connect } from "react-redux"
import { generateBizminerRatios, updateBizminerRatios } from "../../../../store/modules/financialRatios/actions";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import YearBar from "./YearBar";
import Subtitle from "./Subtitle";
import Item from "./Item";

function BizminerRatios({
  currentCompanyBizminerRatios,
  dispatchGenerateBizminerRatios,
  dispatchUpdateBizminerRatios,
}) {
  // Mounted
  useEffect(() => {
    handleGenerateBizminerRatios()
  }, [])

  // Methods
  const handleGenerateBizminerRatios = async () => {
    await dispatchGenerateBizminerRatios()
  }
  const handleUpdateBizminerRatios = async (value, date) => {
    await dispatchUpdateBizminerRatios(value, date)
  }

  return (
    <div>
      <YearBar />

      <Subtitle title="Data" />

      <div className="flex items-center mt-5">
        <div className="whitespace-nowrap flex items-center" style={{ minWidth: "22em" }}>
          Average Employees
        </div>
        <div className="flex">
          {currentCompanyBizminerRatios?.averageEmployees?.map((item) => (
            <div className="flex items-center" style={{ width: "10em" }}>
              <BVAInput
                startAdornment
                width="95%"
                size="small"
                key={item.date}
                value={item.value}
                onChange={(value) => handleUpdateBizminerRatios(value, item.date)}
              />
            </div>
          ))}
        </div>
      </div>
      <Item label = "Wages And Labor Cost" dollar = {true} />
      <Item label = "Average Employee Wage" dollar = {true} bold = {true} />
      <Item label = "Officers' Compensation" dollar = {true} />
      <Item label = "Depreciation, Depletion, Amortization" dollar = {true} />
      <Item label = "Pre-Tax Net Profit" dollar = {true} />
      <Item label = "Discretionary Owner Earnings" dollar = {true} bold = {true} />

      <Subtitle title="Cash Flow / Solvency" />

      <Item label = "Accounts Payable : Business Revenue" tooltip = "Accounts Payable / Business Revenue" percent = {true} />
      <Item label = "Current Ratio" tooltip = "Current Assets / Current Liabilities" />
      <Item label = "Quick Ratio" tooltip = "( Cash + Marketable Securities + Accounts Receivable ) / Current Liabilities" />
      <Item label = "Days Payable" tooltip = "( Accounts Payable / Cost of Sales ) × 365" />
      <Item label = "Current Liabilities : Inventory" tooltip = "Current Liabilities / Inventory" percent = {true} />
      <Item label = "Net Working Capital : Business Revenue" tooltip = "(Current Assets - Current Liabilities) / Business Revenue" percent = {true} />
      <Item label = "Cost of Sales : Accounts Payable" tooltip = "Cost of Sales / Accounts Payable" percent = {true} />
      <Item label = "Cost of Sales : Inventory" tooltip = "Cost of Sales / Inventory" percent = {true} />

      <Subtitle title="Profitability" />

      <Item label = "EBITDA : Business Revenue" tooltip = "EBITDA / Business Revenue" percent = {true} />
      <Item label = "Pre-Tax Return On Assets" tooltip = "Pre-Tax Net Profit / Total Assets" percent = {true} />
      <Item label = "Pre-Tax Return on Net Worth" tooltip = "Pre-Tax Net Profit / Total Equity" percent = {true} />
      <Item label = "Pre-Tax Return on Business Revenue" tooltip = "Pre-Tax Net Profit / Business Revenue" percent = {true} />
      <Item label = "Discretionary Owner Earnings" dollar = {true} />
      <Item label = "After-Tax Return On Assets" tooltip = "After-Tax Net Profit / Total Assets" percent = {true} />
      <Item label = "After-Tax Return On Net Worth" tooltip = "After-Tax Net Profit / Total Equity" percent = {true} />
      <Item label = "After-Tax Return On Business Revenue" tooltip = "After-Tax Net Profit / Business Revenue" percent = {true} />
      <Item label = "Pre-Tax Profit / Employee" tooltip = "Pre-Tax Net Profit / Average Employees" dollar = {true} />
      <Item label = "Owner Earnings / Employee" tooltip = "Discretionary Owner Earnings / Average Employees" dollar = {true} />

      <Subtitle title="Efficiency" />

      <Item label = "Assets : Business Revenue" tooltip = "Total Assets / Business Revenue" />
      <Item label = "Days Inventory" tooltip = "( Inventory / Cost of Sales ) × 365" />
      <Item label = "Days Receivables" tooltip = "( Accounts Receivable / Business Revenue ) × 365" />
      <Item label = "Current Asset Turnover" tooltip = "Business Revenue / Current Assets" />
      <Item label = "Fixed Asset Turnover" tooltip = "Business Revenue / Fixed Assets" />
      <Item label = "Gross Profit Margin" tooltip = "Gross Profit / Business Revenue" percent = {true} />
      <Item label = "Sales Per Employee" tooltip = "Business Revenue / Average Employees" dollar = {true} />
      <Item label = "Inventory Turnover" tooltip = "Business Revenue / Inventory" />
      <Item label = "Receivables Turnover" tooltip = "Business Revenue / Accounts Receivable" />
      <Item label = "Total Asset Turnover" tooltip = "Business Revenue / Total Assets" />
      <Item label = "Working Capital Turnover" tooltip = "Business Revenue / ( Current Assets - Current Liabilities )" />
      <Item label = "Days Working Capital" tooltip = "365 / Working Capital Turnover" />
      <Item label = "Cash Turnover" tooltip = "Business Revenue / Cash" />
      <Item label = "Efficiency Index" tooltip = "Sales Per Employee / Average Employees" />

      <Subtitle title="Debt-Risk" />
      
      <Item label = "Interest Coverage" tooltip = "EBITDA / Interest Expense" />
      <Item label = "Current Liabilities : Net Worth" tooltip = "Current Liabilities / Total Equity" percent = {true} />
      <Item label = "Long-Term Liabilities : Net Worth" tooltip = "Long-Term Liabilities / Total Equity" percent = {true} />
      <Item label = "Loans-Notes Payable : Net Worth" tooltip = "Loans-Notes Payable / Total Equity" percent = {true} />
      <Item
        label = "Modified Z-Score"
        tooltip = "( Operating Income / Total Assets ) × 6.72 + ( Total Equity / Total Liabilities ) × 1.05 + ( Net Working Capital / Total Assets ) × 6.5 + (Discretionary Owner Earnings / Total Assets ) × 3.26"
      />
      <Item label = "Total Liabilities : Net Worth" tooltip = "Total Liabilities / Total Equity" percent = {true} />
      <Item label = "Fixed Assets : Net Worth" tooltip = "Fixed Assets / Total Equity" percent = {true} />

    </div>
  )
}

const mapStateToProps = (state) => ({
  currentCompanyBizminerRatios: state.financialRatios.currentCompanyBizminerRatios,
})

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateBizminerRatios() {
    await dispatch(generateBizminerRatios())
  },
  async dispatchUpdateBizminerRatios(value, date) {
    await dispatch(updateBizminerRatios(value, date));
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(BizminerRatios)
